export default __webpack_public_path__ + "static/media/icon-export.a1bbffd0.svg";